var map = {
	"./Base": 740,
	"./Base/": 740,
	"./Base/index": 740,
	"./Base/index.js": 740,
	"./Base/style": 180,
	"./Base/style.js": 180,
	"./Clutch": 431,
	"./Clutch/": 431,
	"./Clutch/index": 431,
	"./Clutch/index.js": 431,
	"./Clutch/renderComponent": 1652,
	"./Clutch/renderComponent.js": 1652,
	"./Clutch/style": 1304,
	"./Clutch/style.js": 1304,
	"./NewUi": 1024,
	"./NewUi/": 1024,
	"./NewUi/index": 1024,
	"./NewUi/index.js": 1024,
	"./NewUi/style": 1305,
	"./NewUi/style.js": 1305,
	"./OldUi": 1025,
	"./OldUi/": 1025,
	"./OldUi/index": 1025,
	"./OldUi/index.js": 1025,
	"./OldUi/renderComponent": 1653,
	"./OldUi/renderComponent.js": 1653,
	"./OldUi/style": 1306,
	"./OldUi/style.js": 1306,
	"./SpireonNew": 1026,
	"./SpireonNew/": 1026,
	"./SpireonNew/index": 1026,
	"./SpireonNew/index.js": 1026,
	"./SpireonNew/renderComponent": 1654,
	"./SpireonNew/renderComponent.js": 1654,
	"./SpireonNew/style": 1307,
	"./SpireonNew/style.js": 1307,
	"./SpireonOld": 1027,
	"./SpireonOld/": 1027,
	"./SpireonOld/index": 1027,
	"./SpireonOld/index.js": 1027,
	"./SpireonOld/renderComponent": 1655,
	"./SpireonOld/renderComponent.js": 1655,
	"./SpireonOld/style": 1308,
	"./SpireonOld/style.js": 1308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;